// Import getParamValue from the leaf module (not the `@/util` barrel): `@/util`
// imports the store, so importing it here would be a store → plugin → util cycle.
import { getParamValue } from '@/utils/url.utils'

const MARKETPLACE_TYPE_PREFIX = 'marketplace/'
// The same body class Utils.disallowPDFRender / allowPDFRender toggle; the PDF
// exporter waits (up to 60s) for it to clear before each screenshot.
const PDF_RENDER_WAITING_CLASS = 'waiting'
// Covers the Unleash load plus the catalogue fetch's full retry budget (3 × 8s + 1.5s
// backoff), and still leaves room under the exporter's 60s wait for the embed's own
// 12s fallback (35 + 12 = 47s).
export const UNRESOLVED_MARKETPLACE_HOLD_MS = 35000

export const unresolvedMarketplaceSlideType = (state, getters) => {
  const type = state.slideActive?.type
  if (typeof type !== 'string' || !type.startsWith(MARKETPLACE_TYPE_PREFIX)) return null
  return getters['embedApp/customSlideTypeByType'](type) ? null : type
}

// A `marketplace/` slide only renders its plugin embed once the marketplace
// catalogue has loaded; until then nothing on the stage sets `body.waiting`, so a
// capture would screenshot an empty slide. Hold the flag across that gap.
export const createMarketplaceCaptureRenderHoldPlugin = ({
  isCapture = () => getParamValue('capture', window.location.href) === 'true',
  holdRender = () => document.body.classList.add(PDF_RENDER_WAITING_CLASS),
  releaseRender = () => document.body.classList.remove(PDF_RENDER_WAITING_CLASS),
  holdMs = UNRESOLVED_MARKETPLACE_HOLD_MS,
} = {}) => (store) => {
  if (!isCapture()) return

  let heldType = null
  let releaseTimer = null

  const cancelReleaseTimer = () => {
    if (releaseTimer) clearTimeout(releaseTimer)
    releaseTimer = null
  }

  store.watch(unresolvedMarketplaceSlideType, (unresolvedType) => {
    cancelReleaseTimer()
    if (unresolvedType) {
      heldType = unresolvedType
      holdRender()
      releaseTimer = setTimeout(() => {
        releaseTimer = null
        heldType = null
        releaseRender()
      }, holdMs)
      return
    }
    if (heldType === null) return
    // Resolved in place: the plugin embed now mounting owns the flag, so leave it set.
    const resolvedInPlace = store.state.slideActive?.type === heldType
    heldType = null
    if (!resolvedInPlace) releaseRender()
  }, { immediate: true })
}

export default createMarketplaceCaptureRenderHoldPlugin()
